// extracted by mini-css-extract-plugin
export var chip = "_9j-0";
export var filterDropdown = "_9j-5";
export var filterItem = "_9j-6";
export var icon = "_9j-1";
export var removeButton = "_9j-3";
export var removeIcon = "_9j-4";
export var separator = "_9j-2";